import { motion } from "framer-motion";
import "./Footer.scss";
import { FaInstagram } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa6";
import BtnCard from "./btnCard/BtnCard";
import { TfiHome } from "react-icons/tfi";
import { GoMail } from "react-icons/go";
import { images } from "../../utils/images";
import { formRange } from "../../utils/enum";
import { baseUrl } from "../../utils/apiData";
import useExecuteContext from "../../utils/hooks/executeContext";

const Footer = () => {
  const { setShowContact, setFormType, footerData } = useExecuteContext();
  return (
    <footer>
      <img src={images.pattern} alt="Pattern" className="pattern_right" />

      <img src={images.pattern} alt="Pattern" className="pattern_left" />

      <section
        className="footer p_t"
        style={{
          background: `linear-gradient(to Top, rgba($primary, 1), rgba($primary, 0.6) 50%, rgba($primary, 0.1)), url(${baseUrl}/${footerData?.image})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "cover",
        }}
      >
        <div className="content_wrap">
          <h3 className="gold">
            {footerData?.title &&
              footerData?.title
                ?.split("")
                .map((char, k) => (
                  <motion.span
                    initial={{ translateX: 24, opacity: 0 }}
                    whileInView={{ translateX: 0, opacity: 1 }}
                    transition={{
                      duration: 0.4,
                      ease: "easeInOut",
                      delay: 0.03 * k,
                    }}
                    key={k}
                  >
                    {char}
                  </motion.span>
                ))
                .concat("")}
          </h3>
          <div className="bi_drid">
            <BtnCard
              icon={<TfiHome />}
              title={footerData?.box_title_1}
              subTitle={footerData?.box_heading_1}
              clickHandler={() => {
                setFormType(formRange.DOMESTIC);
                setShowContact(true);
              }}
            />

            <BtnCard
              icon={<GoMail />}
              title={footerData?.box_title_2}
              subTitle={footerData?.box_heading_2}
              clickHandler={() => {
                setFormType(formRange.INTERNATIONAL);
                setShowContact(true);
              }}
            />
          </div>
          <div className="bottom_line">
            <div className="img_wrap">
              <img src={images.logo} alt="Brand Logo" />
            </div>
            <div className="social">
              {footerData?.linkedin_link && (
                <a href="/" target="_blank">
                  <FaLinkedinIn />
                </a>
              )}
              {footerData?.facebook_link && (
                <a href={footerData?.facebook_link} target="_blank">
                  <FaFacebookF />
                </a>
              )}
              {footerData?.instagram_link && (
                <a href={footerData?.instagram_link} target="_blank">
                  <FaInstagram />
                </a>
              )}
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
